import React, { useEffect, useRef, useState } from 'react'
import { ProgressLoader } from '../Elements';
import ConfirmationModal from '../ConfirmationModal';
import MaterailTable from '../Elements/MaterialTable';
import { getMatchStatusInfo } from '../TableMatchStatusView';
import { tableEmptyMessages } from '../../../constants/messages/tableEmptyMessages';
import { ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { PersonAddDisabled } from '@mui/icons-material';
import { CustomerListType } from '../../../common/types';
import { FaEllipsisV } from 'react-icons/fa';
import { ApiResponseType } from '../../../common/api/apiHelper';
import commonNetwork from '../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import HtmlTooltip from '../HtmlTooltilp';
import { successMessages } from '../../../constants/messages/successMessages';
import { errorMessages } from '../../../constants/messages/errorMessages';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { getWebCustomerList } from '../../../store/slices/webCustomersSlice';
import { useLoading } from '../../../hooks/useLoading';

interface UserCustomerMatchTableProps {
    formFilterRef: React.Ref<HTMLDivElement> | any;
    tableSelectedRows: React.RefObject<any>;
    selectedUser: any;
    showTable: boolean;

    //PAgination için
    page: number;
    pageSize: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    setPageSize: React.Dispatch<React.SetStateAction<number>>;
    filterFormValues: any;
}

const UserCustomerMatchTable: React.FC<UserCustomerMatchTableProps> = ({
    formFilterRef,
    tableSelectedRows,
    selectedUser,
    page,
    pageSize,
    setPage,
    setPageSize,
    filterFormValues,
    showTable }) => {

    const thunkdispatch = useDispatch<ThunkDispatch<any, any, any>>();


    // useRef's
    const confirmModelRef = useRef();

    // useState's
    const [operationsLoading, setOperationsLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [dropdownMenuId, setDropdownMenuId] = useState("");
    const [dropdownAllValues, setDropdownAllValues] = useState<CustomerListType>();
    const isopenMenu = Boolean(anchorEl);

    const {
        customerList,
        totalCount,
        currentPage,
        isFetching,
        isloadingIntegration,
        isFetchComplete
    } = useSelector((state: any) => state.webCustomers);

    const loading = useLoading(isFetching);

    const LinearColor = () => {
        if (operationsLoading) {
            return <ProgressLoader />
        }
        return null;
    };

    const handleClickMenu = (event: any, row: any) => {
        setDropdownAllValues(row);
        setDropdownMenuId(row.customerId);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRemoveCustomer = async (customerId: any) => {
        setOperationsLoading(true);
        const parameters = {
            customerId: parseInt(customerId),
            userId: parseInt(selectedUser)
        }

        let result: ApiResponseType;
        try {
            result = await commonNetwork.post("/CustomerUser/delete", parameters);

            if (result.isSuccess) {
                toast.success(successMessages.connectionRemoved);
                setAnchorEl(null);
            } else {
                toast.error(result.errorMessage);
            }
        } catch (error) {

        } finally {
            setOperationsLoading(false);
            formFilterRef.current?.onSubmit();
        }
    }

    const DropdownMenu = (row: any) => {
        return (
            <Menu
                id="customer-operations"
                anchorEl={anchorEl}
                open={isopenMenu}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={() => {
                        handleRemoveCustomer(dropdownAllValues?.customerId)
                    }}
                >
                    <ListItemIcon>
                        <PersonAddDisabled fontSize='small' color='error' />
                    </ListItemIcon>
                    Yetkiyi Kaldır
                </MenuItem>
            </Menu>
        )
    }

    const headCells = [
        {
            id: 'customerId',
            numeric: false,
            disablePadding: true,
            label: 'ID',
            isprimary: true,
            className: "min-w-[80px]",
            colWidth: 10,
            hide: true
        },
        {
            id: "operations",
            numeric: false,
            label: "İşlemler",
            colWidth: 20,
            isRender: true,
            disableSortIcon: true,
            renderRow: (row: any) => (
                <div className={row.isMatchToSelectedUser ? "flex justify-around items-center" : "hidden"}>
                    <a id="report-operations-a"
                        aria-controls={isopenMenu ? 'report-operations' : undefined}
                        aria-haspopup="true"
                        aria-expanded={isopenMenu ? 'true' : undefined}
                        className="cursor-pointer"
                        onClick={(event) => handleClickMenu(event, row)}
                    >
                        <FaEllipsisV
                            className="block sm:block ml-1 h-3 w-3 font-light	"
                            aria-hidden="true"
                        />
                    </a>
                    <DropdownMenu />
                </div>
            )
        },
        {
            id: "customerCode",
            numeric: false,
            label: "Müşteri Kodu",
            className: "min-w-[135px]",
            forcealign: "center",
            maxLength: 15,
            colWidth: 20
        },
        {
            id: "customerName",
            numeric: false,
            label: "Müşteri Adı",
            className: "min-w-[170px]",
            maxLength: 15,
            colWidth: 20

        },
        {
            id: "isMatchToSelectedUserStatus",
            numeric: false,
            disablePadding: false,
            label: "Bağlı Kullanıcı Durumu",
            colWidth: 20,
            className: "min-w-[195px]",
            isRender: true,
            renderRow: (row: any) => (
                <div className="flex justify-around items-center">
                    {getMatchStatusInfo(row.isMatchToSelectedUser)}
                </div>
            )
        },
        {
            id: "city",
            numeric: false,
            label: "Müşterinin Şehri",
            className: "min-w-[155px]",
            maxLength: 15,
            colWidth: 20
        },
        {
            id: "district",
            numeric: false,
            label: "Müşterinin İlçesi",
            className: "min-w-[155px]",
            maxLength: 15,
            colWidth: 20
        },
        {
            id: "email",
            numeric: false,
            label: "E-Posta Adresi",
            className: "min-w-[200px]",
            maxLength: 30,
            colWidth: 30
        },
        {
            id: "phone",
            numeric: false,
            label: "Telefon",
            colWidth: 20,
            className: "min-w-[110px]",
            maxLength: 15
        },
        {
            id: "customerUserList",
            numeric: false,
            label: "Bağlı Kullanıcılar",
            colWidth: 20,
            className: "min-w-[155px]",
            maxLength: 15,
            isRender: true,
            disabledTooltip: true,
            renderRow: (row: any) => {
                const maxLength = 15; // Belirli bir karakter uzunluğu
                const customerList = row.customerUserList ? row.customerUserList.join(", ") : "";
                const truncatedCustomerList = customerList.length > maxLength
                    ? customerList.substring(0, maxLength) + "..."
                    : customerList;

                return (
                    <HtmlTooltip
                        title={
                            <React.Fragment>
                                <Typography color="inherit">Müşteriye Bağlı Kullanıcılar</Typography>
                                <label className="font-bold">Kullanıcılar: </label> {customerList}
                            </React.Fragment>
                        }
                    >
                        <span>{truncatedCustomerList}</span>
                    </HtmlTooltip>
                )
            }
        }
    ];

    return (
        <>
            {LinearColor()}
            <ConfirmationModal ref={confirmModelRef} />
            <MaterailTable
                ref={tableSelectedRows}
                headerCells={headCells}
                tableData={showTable ? customerList || [] : []}
                isRowSelect
                isLoading={loading}
                emptyMessage={customerList != null ? tableEmptyMessages.isFilteredDataNotFound : tableEmptyMessages.emptyString}
                onPageChange={(newPage) => {
                    setPage(newPage);
                    thunkdispatch(getWebCustomerList({
                        ...filterFormValues,
                        pageNumber: newPage,
                        pageSize: pageSize
                    }));
                }}
                onRowsPerPageChange={(newRows) => {
                    setPageSize(newRows);
                    setPage(1);
                    thunkdispatch(getWebCustomerList({
                        ...filterFormValues,
                        pageNumber: 1,
                        pageSize: newRows
                    }));
                }}
                totalDataCount={totalCount}
                currentPage={currentPage}
            />
        </>
    )
}

export default UserCustomerMatchTable;
